<template>
  <div style="margin: 0;padding-left: 8px;">
    <el-image
      style="width: 300px;height: 300px;"
      :src="OSS_PIC_BASE_URL + info.pic_url"
      :preview-src-list="preview_src_list"
    ></el-image>
  </div>
</template>

<script>
import { OSS_PIC_BASE_URL, OSS_FILE_BASE_URL } from "@/config/config";
export default {
  data() {
    return {
      OSS_PIC_BASE_URL,
      OSS_FILE_BASE_URL
    };
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: ""
    }
  },
  computed: {
    preview_src_list() {
      if (this.info?.pic_list?.length) {
        return this.info.pic_list.map(item => {
          return OSS_PIC_BASE_URL + item.pic_url;
        });
      }
      return [];
    }
  }
};
</script>

<style></style>
